module.exports = __webpack_public_path__ + "media/app/img/unreal-logo128-93050dda15790de6f5eee0125f22de0a.png";